import { push } from '@lagunovsky/redux-react-router'
import { PATH_NAME } from 'app/constants'
import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { API_LANGUAGE_MAPPING } from 'global/i18n/constants'
import { localeSelector } from 'global/i18n/selectors'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { callApiAsync } from 'services/api/callAPIAsync'
import { restoreBooking } from './reducer'

//TODO: The API endpoint doesn't work.
function* restoreBookingCallApiSaga({ payload }) {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? ''
    const cinemaid = Number(localStorage.getItem('cinemaid'))
    yield call(callApiAsync, 'cartRelease', { language })
    const { data, error } = yield call(callApiAsync, 'bookingRestoreToCard', { ...payload, cinemaid, language })
    if (error) {
        console.error(error)
        yield put(setErrorMessage(error))
        return
    }
    if (data.items_tickets.length > 0) {
        yield put(push(PATH_NAME.YOUR_ORDER))
        return
    }
    yield put(push(PATH_NAME.BUY_TICKET_VOUCHER))
}

export default function* restoreBookingSaga() {
    yield all([takeLatest(restoreBooking.type, restoreBookingCallApiSaga)])
}
